(function () {
  /**
   * @ngdoc component
   * @name abxAppSwitcher
   *
   * @description
   * A component to be used in conjunction with the app header to switch the current app
   */
  angular
    .module("akitabox.ui.components.appHeader")
    .component("abxAppSwitcher", {
      bindings: {
        appTitle: "<abxAppTitle",
        isMobile: "<abxIsMobile",
        isSuperAdmin: "<abxIsSuperAdmin",
        organization: "<abxOrganization",
      },
      controller: AbxAppSwitcherController,
      controllerAs: "vm",
      templateUrl:
        "app/core/ui/components/app-header/components/app-switcher/app-switcher.component.html",
    });

  /* @ngInject */
  function AbxAppSwitcherController(
    // Angular
    $location,
    // Services
    CustomerAccountService,
    EnvService,
    UserService,
    RedirectService,
    FeatureFlagService
  ) {
    var self = this;

    // =================
    // Attributes
    // =================
    self.isOpen = false;
    self.menuItems = [];

    self.$onInit = function () {
      if (self.organization && self.organization.customer_account) {
        CustomerAccountService.getById(self.organization.customer_account)
          .then((customerAccount) => {
            self.menuItems = _buildMenuItems(
              self.organization,
              customerAccount
            );
          })
          .catch((err) => {
            self.menuItems = _buildMenuItems(self.organization);
          });
      } else {
        self.menuItems = _buildMenuItems(self.organization);
      }
    };

    // =================
    // Public Functions
    // =================

    self.toggleOpen = function (state) {
      if (state) {
        self.isOpen = state;
      } else {
        self.isOpen = !self.isOpen;
      }
    };

    // =================
    // Private Functions
    // =================

    function goToMobile() {
      RedirectService.redirectToMobile($location.path());
    }

    /**
     * Enable link to CM if the Org has it enabled, or we want to show the 'Call to Action' page
     */
    function getUrl(page) {
      var url;
      var subdomain = EnvService.getSubdomain();
      switch (page) {
        case "site-admin":
          url = EnvService.getSiteAdminUrl();
          break;
        case "cm":
          url = EnvService.getCmUrl("/cm", subdomain);
          break;
        case "customer-account-settings":
          url = EnvService.getCustomerAccountSettingsUrl(
            "/account_settings",
            self.organization.customer_account
          );
          break;
        case "org-settings":
          url = EnvService.getOrgSettingsUrl(
            "/organization/settings",
            subdomain
          );
          break;
        case "catalogs":
          url = EnvService.getCatalogsRoute("/catalogs/");
          break;
        default:
          url = EnvService.getBaseUrl(page, self.isMobile, subdomain);
      }
      return url;
    }

    function _buildMenuItems(organization, customerAccount) {
      const user = UserService.getCurrent();
      const permissions = UserService.getPermissions();
      const identity = user.identity;
      const showCm = organization ? organization.show_rpi_fci : false;
      const catalogsFlagEnabled =
        FeatureFlagService.isEnabled("catalogs") || false;
      const accountSettingsUIEnabled =
        FeatureFlagService.isEnabled("account-settings-ui") || false;

      const items = [
        {
          title: "ListView",
          dest: getUrl("buildings"),
        },
      ];

      if (organization) {
        items.push({
          title: "PlanView",
          dest: getUrl("plan/buildings"),
        });
      }

      // Can only access the app with all 'rpam' permissions
      if (
        showCm &&
        permissions.assembly.rpam &&
        permissions.condition.rpam &&
        permissions.cost_line.rpam
      ) {
        items.push({
          title: "Capital Management",
          dest: getUrl("cm"),
          targetSelf: true,
        });
      }

      if (catalogsFlagEnabled) {
        items.push({
          title: "Catalogs",
          dest: getUrl("catalogs"),
          targetSelf: true,
        });
      }

      if (permissions.is_administrator) {
        items.push({
          title: "Organization Settings",
          dest: getUrl("org-settings"),
          targetSelf: true,
        });
      }

      if (
        accountSettingsUIEnabled &&
        organization &&
        customerAccount &&
        permissions.is_administrator &&
        customerAccount.modify_identities.includes(identity.email)
      ) {
        items.push({
          title: "Account Settings",
          dest: getUrl("customer-account-settings"),
          targetSelf: true,
        });
      }
      if (self.isSuperAdmin) {
        items.push({
          title: "Site Admin",
          dest: getUrl("site-admin"),
          targetSelf: true,
        });
      }

      if (self.appTitle === "ListView" || self.appTitle === "PlanView") {
        items.push({
          title: "Use Mobile Site",
          onClick: goToMobile,
        });
      }

      return items;
    }
  }
})();
